import appBase from '../index.js';


class MaintenanceController {
  /**
   * @param {app.AuthenticationService} appAuthenticationService
   * @param {angularGettext.Catalog} gettextCatalog Gettext catalog.
   * @ngInject
   */
  constructor(appAuthenticationService, gettextCatalog) {
    this.authentication_ = appAuthenticationService;
    this.gettextCatalog = gettextCatalog;
  }

  get loginConfig() {
    return this.authentication_.loginConfig;
  }
}

const component = {
  bindings: {
    'addClass': '@'
  },
  controller: MaintenanceController,
  template: `
  <div class="{{$ctrl.addClass}} menu-user-msg" ng-show="$ctrl.loginConfig.showloginmsg">
    <span ng-if="$ctrl.gettextCatalog.currentLanguage == 'de'" ng-bind-html="$ctrl.loginConfig.loginmsgde | trustedHtml"></span>
    <span ng-if="$ctrl.gettextCatalog.currentLanguage == 'fr'" ng-bind-html="$ctrl.loginConfig.loginmsgfr | trustedHtml"></span>
    <span ng-if="$ctrl.gettextCatalog.currentLanguage == 'it'" ng-bind-html="$ctrl.loginConfig.loginmsgit | trustedHtml"></span>
    <span ng-if="$ctrl.gettextCatalog.currentLanguage == 'en'" ng-bind-html="$ctrl.loginConfig.loginmsgen | trustedHtml"></span>
  </div>
  `,
};

export const module = appBase.component('appMaintenance', component);
